import {
  largeWidthBreakPoint,
  masterBreakPoint,
  maxWidth600,
} from "themes/default/breakpoints"

export const styles = {
  incell: (theme) => ({
    borderRight: `1px solid ${theme.palette.grey.lighter3}`,
    backgroundColor: theme.palette.background.default,
    position: "relative",
    width: "50%",
    justifyContent: "space-between",
    [maxWidth600]: {
      width: "100%",
    },
    [largeWidthBreakPoint]: {
      justifyContent: "flex-start ",
    },
  }),
  selectForm: {
    m: 1,
    minWidth: 120,
    height: 30,
    maxWidth: "100%",
    pr: 3.5,
    pl: 2.5,
    [maxWidth600]: {
      px: 0,
      m: 0,
    },
  },
  select: (theme) => ({
    color: theme.palette.text.selected,
    fontSize: 18,
    borderRadius: 5,
  }),
  tta_intxt: {
    height: "auto",
    // px: 1,
    pt: 3,
    pr: 5,
    pb: 5,
    pl: 2.5,
    fontSize: 40,
    color: "#71777d",
    wordWrap: "break-word",
    minHeight: 200,
    width: "100%",
    "& input": {
      fontSize: 40,
      // backgroundColor: theme.palette.common.white,
    },
    "& textarea": {
      fontSize: 40,
      lineHeight: 1.5,
      // backgroundColor: theme.palette.common.white,
    },
    "& fieldset": {
      border: "none",
    },
    [masterBreakPoint]: {
      "& textarea": {
        fontSize: 28,
      },
    },
    [maxWidth600]: {
      px: 0,
      "& textarea": {
        fontSize: 16,
      },
    },
    [largeWidthBreakPoint]: {
      px: 0,
      "& textarea": {
        fontSize: 16,
      },
    },
  },
  swapButton: (theme) => ({
    position: "absolute",
    boxShadow: "0 0 0 1px rgba(0,0,0,.05),0 2px 3px 0 rgba(0,0,0,.1)",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: "50%",
    ml: -2.5,
    zIndex: 2,
    top: 8,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    [maxWidth600]: {
      position: "relative",
      alignSelf: "center",
      top: 20,
      // top: "35%",
      // ml: "40%",
    },
  }),
  outcell: (theme) => ({
    position: "relative",
    width: "50%",
    backgroundColor: theme.palette.background.grade,
    [maxWidth600]: {
      width: "100%",
      pt: 3,
    },
  }),
  cellContent: {
    m: "10px 28px 0 20px",
  },
  table: (theme) => ({
    border: `1px solid ${theme.palette.grey.lighter3}`,
    borderRadius: 2,
    minHeight: 500,
    [largeWidthBreakPoint]: {
      minHeight: 0,
    },
  }),
  closeButton: (theme) => ({
    backgroundColor: theme.palette.error.main,
    color: "white",
    position: "absolute",
    right: -15,
    top: -15,
    zIndex: 99,
    "&:hover": {
      backgroundColor: theme.palette.error.main,
      color: "white",
    },
  }),
  moreOutput: (theme) => ({
    borderTop: `2px solid ${theme.palette.background.default}`,
  }),
  moreTitle: (theme) => ({
    color: theme.palette.text.lighter3,
    fontSize: 16,
    fontWeight: 500,
    p: "4px 16px",
    pb: 2.25,
  }),
  moreItem: (theme) => ({
    borderRadius: "0 0 8px 8px",
    borderBottom: `2px solid ${theme.palette.background.default}`,
    p: "4px 16px",
    py: 1,
  }),
  moreText: (theme) => ({
    color: theme.palette.text.lighter4,
    fontSize: 16,
    lineHeight: 1.5,
    whiteSpace: "nowrap",
  }),
  speakButton: {
    alignSelf: "flex-start",
    ml: 6,
    [maxWidth600]: {
      ml: 3,
    },
    [largeWidthBreakPoint]: {
      ml: 3,
    },
  },
  speakButtonOut: {
    mb: 2,
  },
  modalContainer: {
    maxWidth: "80vw",
    borderRadius: 3,
    overflow: "visible",
    // height: "90%",
    maxHeight: "90%",
    minHeight: 500,
    [maxWidth600]: {
      px: 0,
    },
    [largeWidthBreakPoint]: {
      minHeight: 0,
    },
  },
}
